import React from 'react';
import { Github, Linkedin, Mail } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-6">
      <div className="container mx-auto flex justify-between items-center px-4">
        {/* Copyright */}
        <div className="text-sm">
          &copy; {new Date().getFullYear()} Project Gallery PRG. All rights
          reserved.
        </div>

        {/* Social Links */}
        <div className="flex space-x-6">
          <a
            href="https://github.com/YahefuYusufu"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-300 transition-colors duration-200"
            title="GitHub Profile"
          >
            <Github
              size={24}
              className="hover:scale-110 transition-transform duration-200"
            />
          </a>
          <a
            href="https://www.linkedin.com/in/yahefu-yusufu-790072ba/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-300 transition-colors duration-200"
            title="LinkedIn Profile"
          >
            <Linkedin
              size={24}
              className="hover:scale-110 transition-transform duration-200"
            />
          </a>
          <a
            href="mailto:parguzatt@gmail.com"
            className="hover:text-gray-300 transition-colors duration-200"
            title="Send Email"
          >
            <Mail
              size={24}
              className="hover:scale-110 transition-transform duration-200"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
